export const BOARD_MEMBERS_DATA_UPDATED = "BOARD_MEMBERS_DATA_UPDATED";
export const BOARD_MEMBERS_DATA_SNOOZED = "BOARD_MEMBERS_DATA_SNOOZED";
